<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-form :submit="submitSearch">
          <v-expansion-panels variant="accordion" v-model="filterPanel">
            <v-expansion-panel value="searchFiltersPanel" rounded="lg">
              <v-expansion-panel-title
                                       style="color:#000000 !important; 
                                       background-color: #e0e0e0ff; 
                                       opacity: 1 !important">
                <v-row style="opacity: 1 !important">
                  <v-col cols="12">
                    <span class="v-card-title">Filtro de pesquisa</span>
                  </v-col>
                </v-row>
              </v-expansion-panel-title>
              <v-expansion-panel-text class="bg-grey-lighten-2">
                <v-row>
                  <v-col cols="12">
                    <MultiSelectCashier
                                        :selected-group="cashiers_group_id"
                                        @update:modelValue="selectedCashiers" />
                  </v-col>
                  <v-col cols="12">
                    <v-row align="center">
                      <v-col cols="2">
                        <v-label>Período</v-label>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field type="date" label="De" density="compact" v-model="filters.start_date">
                        </v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field type="date" label="Até" density="compact" v-model="filters.end_date">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-if="hasAdminAccess"
                         cols="12"
                         md="9"
                         sm="8">
                    <AutocompleteSelectGroup @selected="selectedGroup" />
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-btn color="warning" @click="clearFilters()">
                    <v-icon class="mr-2">mdi-broom</v-icon>
                    Limpar pesquisa
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" type="submit">
                    <v-icon class="mr-2">mdi-magnify</v-icon>
                    Pesquisar
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title v-if="lstObjects?.length > 0">
            <v-spacer></v-spacer>
            <v-tooltip location="bottom" text="Exportar PDF">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon variant="plain" density="compact" @click="downloadCashBook()">
                  <v-icon>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip location="bottom" text="Exportar Excel">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon variant="plain" density="compact" @click="exportCashBook()">
                  <v-icon>mdi-file-excel-box</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <v-card>
              <v-card-title>
                <v-row align="center">
                  <v-col cols="2" style="height:71px; line-height:71px;">
                    Histórico
                  </v-col>
                  <v-col cols="9" v-if="showSelectHeaders">
                    <v-select
                              label="Campos da tabela"
                              item-title="title"
                              return-object
                              :items="headers"
                              hide-details
                              multiple
                              clearable
                              chips
                              v-model="selectedHeaders"
                              density="compact"
                              @update:modelValue="saveSelectedHeaders"></v-select>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="1">
                    <v-tooltip location="top">
                      <template v-slot:activator="{ props }">
                        <v-btn icon density="compact"
                               v-bind="props"
                               variant="text">
                          <v-icon color="grey-lighten-1"
                                  @click="showSelectHeaders = !showSelectHeaders">
                            mdi-cog
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Configurar Cabeçalhos</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text>
                <v-data-table
                              :headers="selectedHeaders"
                              :items="itemList"
                              :search="searchFilter"
                              :itemsPerPage="50"
                              return-object
                              expand-on-click
                              class="elevation-1">
                  <template v-slot:item.is_human="{ item }">
                    <span>{{ item.is_human ? "PF" : "PJ" }}</span>
                  </template>
                  <template v-slot:item.type="{ value }">
                    <v-chip v-if="$CASHIER_MOVEMENT_TYPES_DIC[value]">{{
                      $CASHIER_MOVEMENT_TYPES_DIC[value].label
                    }}</v-chip>
                  </template>
                  <template v-slot:item.description="{ item }">
                    {{ item.description || item.receipt?.description || item.cashier_transfer?.description
                    }}
                  </template>
                  <template v-slot:item.movement_date="{ item }">
                    <span>{{
                      $moment(item.movement_date).format(item.cashier_id ? "DD/MM/YYYY HH:mm" : 'DD/MM/YYYY')
                    }}</span>
                  </template>
                  <template v-slot:item.amount_in="{ value }">
                    <span class="text-green">{{
                      value ?
                      $filters.currency(value, 'BRL')
                      : ''
                    }}</span>
                  </template>
                  <template v-slot:item.amount_out="{ value }">
                    <span class="text-red">{{
                      value ?
                      $filters.currency(value, 'BRL')
                      : ''
                    }}</span>
                  </template>
                  <template v-slot:item.amount_after="{ item }">
                    <span>{{
                      $filters.currency(item.amount_after, 'BRL')
                    }}</span>
                  </template>
                  <template v-slot:expanded-row="{ columns, item }">
                    <tr>
                      <td class="text-center bg-detail-lighten-1" :colspan="columns.length"><span
                              v-if="!item.receipt">Sem </span>
                        Lançamentos</td>
                    </tr>
                    <tr v-if="item.receipt">
                      <td class="bg-detail-lighten-2">&nbsp;</td>
                      <td class="bg-detail-lighten-2">ID</td>
                      <td class="bg-detail-lighten-2">Situacao</td>
                      <td class="bg-detail-lighten-2">Vencimento</td>
                      <td class="bg-detail-lighten-2">Pagamento</td>
                      <td class="bg-detail-lighten-2">Valor</td>
                      <td class="bg-detail-lighten-2">Criação</td>
                      <td class="bg-detail-lighten-2">&nbsp;</td>
                    </tr>
                    <tr v-for="invoice in item.receipt?.invoices">
                      <!-- <td :colspan="columns.length">
                            More info about {{ item.name }}
                        </td> -->
                      <td class="bg-detail-lighten-3"></td>
                      <td class="bg-detail-lighten-3">
                        {{ invoice.id }}
                      </td>
                      <td class="bg-detail-lighten-3">
                        <v-chip :color="$INVOICE_STATUS_DIC[invoice.status]?.color || 'grey'">{{
                          $INVOICE_STATUS_DIC[invoice.status]
                          ? $INVOICE_STATUS_DIC[invoice.status].label
                          : invoice.status
                        }}</v-chip>
                      </td>
                      <td class="bg-detail-lighten-3">{{
                        $moment.parseZone(invoice.due_date).format("DD/MM/YYYY") }}</td>
                      <td class="bg-detail-lighten-3">
                        <span v-if="invoice.payment_date">
                          {{ $moment.parseZone(invoice.payment_date).format("DD/MM/YYYY") }}
                        </span>
                      </td>
                      <td class="bg-detail-lighten-3">
                        {{ $filters.currency(invoice.amount, "BRL") }}
                      </td>
                      <td class="bg-detail-lighten-3">
                        {{ $moment.parseZone(invoice.created_at).local().format("DD/MM/YYYY HH:mm:ss") }}
                      </td>
                      <td class="bg-detail-lighten-3"></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <CashBook v-if="lstObjects.length > 0"
                      :user="user"
                      :history="lstObjects"
                      :startDate="filters.start_date"
                      :endDate="filters.end_date"
                      :selectedCashiers="filters.cashier_ids"></CashBook>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AutocompleteSelectGroup from "../components/AutocompleteSelectGroup.vue";
import CashBook from "../components/CashBook.vue";
import MultiSelectCashier from "../components/MultiSelectCashier.vue";
import api from '@/services'

export default {
  components: {
    AutocompleteSelectGroup,
    CashBook,
    MultiSelectCashier,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      filterPanel: "searchFiltersPanel",
      headers: [
        { title: "Usuário", align: "start", key: "user_name", sortable: false },
        { title: "Caixa", align: "start", key: "cashier_name", sortable: false },
        { title: "Data", align: "start", key: "movement_date", sortable: false },
        { title: "Tipo", align: "start", key: "type", sortable: false },
        { title: "Descrição", align: "start", key: "description", sortable: false },
        { title: "Entrada", align: "end", key: "amount_in", color: "green", sortable: false },
        { title: "Saída", align: "end", key: "amount_out", color: "red", sortable: false },
        { title: "Saldo", align: "end", key: "amount_after", sortable: false },
      ],
      selectedHeaders: [],
      showSelectHeaders: false,
      lstObjects: [],
      filters: {
        withUser: true,
        is_human: null,
        group_id: null,
        cashier_ids: [],
        start_date: null,
        end_date: null,
        types: [1, 2]
      },
      cashiers_group_id: null,
      editCashierModel: {},
      dialogCreateEdit: false,
      searchFilter: null,
    };
  },
  created() {
    var vm = this;

    vm.loadParameters();
  },
  mounted() { },
  activated() { },
  destroyed() {
    const vm = this;

    api.abortController.abort();
  },
  methods: {
    saveSelectedHeaders() {
      var vm = this;
      try {
        localStorage.setItem(
          "_cashier_movement_list_headers",
          JSON.stringify(vm.selectedHeaders)
        );
      } catch (error) {
        console.error(error);
      }
    },
    selectedGroup(group) {
      var vm = this;

      vm.filters.group_id = group?.id;
      vm.cashiers_group_id = group?.id;
    },
    selectedCashiers(cashiers) {
      var vm = this;

      vm.filters.cashier_ids = cashiers.map(c => c.id);
    },
    loadParameters() {
      var vm = this;

      try {
        let _headers = localStorage["_cashier_movement_list_headers"];
        vm.selectedHeaders = _headers ? JSON.parse(_headers) : vm.headers;
      } catch (error) {
        vm.selectedHeaders = vm.headers;
      }

      if (api.storage.isGroupSelected()) {
        vm.cashiers_group_id = api.storage.selectedGroup().id;
      }
      if (vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value) {
        vm.selectedHeaders.push({ title: "Grupo", align: "start", key: "group_acronym", sortable: false });
        localStorage.removeItem("_cashier_movement_list_headers");
      }
    },
    clearFilters() {
      var vm = this;

      vm.searchFilter = null;
      vm.filters = {
        withUser: true,
        is_human: null,
        types: [],
        group_id: null,
        cashier_ids: [],
        start_date: null,
        end_date: null,
      };
    },
    submitSearch() {
      var vm = this;

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.cashierMovement
            .list(vm.filters)
            .then((result) => {
              vm.lstObjects = result || [];
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
              if (result?.data?.length > 0) {
                vm.filterPanel = "";
              }
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    downloadCashBook() {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.pdf
            .downloadCashBook(vm.filters)
            .then((result) => {
              // create file link inx browser's memory
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;

              link.setAttribute('download', `LivroCaixa_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.pdf`); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
            }).catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    exportCashBook() {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.excel
            .exportCashBook(vm.filters)
            .then((result) => {
              // create file link inx browser's memory
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;

              link.setAttribute('download', `LivroCaixa_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.xlsx`); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
            }).catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    }
  },
  computed: {
    itemList() {
      const vm = this;

      let currentValue = vm.lstObjects.reduce((prev, curr) => {
        const old = prev.find(o => o.cashier_id === curr.cashier_id);

        if (!old) {
          prev.push({
            cashier_id: curr.cashier_id,
            amount_before: curr.amount_before
          })
        }
        return prev;
      }, []).reduce((prev, curr) => prev + curr.amount_before, 0);

      const ret = vm.lstObjects?.length > 0 ? [{
        cashier_id: null,
        user_name: '',
        cashier_name: 'INICIAL',
        movement_date: new Date(),
        amount: '',
        amount_before: '',
        amount_after: currentValue,
        receipt: { description: 'Saldo Anterior' }
      }] : [];

      return ret.concat(vm.lstObjects.map(o => {
        let ret = Object.assign({ ...o, amount_before: currentValue });
        currentValue += ret.amount;
        ret['amount_after'] = currentValue;
        return ret;
      }));
    },
    hasAdminAccess() {
      const vm = this;

      return vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value;
    }
  },
  watch: {
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>